// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__10AoW","approved":"Status_approved__2vPE-","rejected":"Status_rejected__3I871","expired":"Status_expired__2h9qf","label":"Status_label__1JWe7"};